import { QueryClient, useQuery } from "@tanstack/react-query";
import { MappedLoginBlock } from "@/models/login/loginBlockMapper";

const useLoginBlock = () =>
  useQuery<MappedLoginBlock, Error>({
    queryKey: ["loginBlock"],
    queryFn: async (): Promise<MappedLoginBlock> => {
      const response = await fetch("/api/contentful/login-form");
      if (!response.ok) {
        throw new Error(`Failed to fetch login block: ${response.statusText}`);
      }
      return response.json();
    },
    staleTime: 1000 * 60 * 60 * 24, // Keep fresh for 24 hours
    retry: 1 // Retry once on failure
  });

export default useLoginBlock;

// TO DO - Ensure this is actually pre-fetching the data and not just fetching it again
export const prefetchLoginBlock = async (queryClient: QueryClient) => {
  await queryClient.prefetchQuery({
    queryKey: ["loginBlock"],
    queryFn: async (): Promise<MappedLoginBlock> => {
      const response = await fetch("/api/contentful/login-form");
      if (!response.ok) {
        throw new Error("Failed to pre-fetch login block");
        
      }
      return response.json();
    }
  });
};
